/**
 * Payer Connections — AC-7 action targets and labels.
 */

import type { FoldedPayer, RailView } from './types';

/**
 * PRD Q3 is open: Stedi's per-enrollment portal URL format is not known,
 * and the passthrough only carries `portal_url` when Stedi's payload has
 * one. Until Q3 is answered the link falls back to the portal home, which
 * is the PRD's own recommendation.
 */
export const STEDI_PORTAL_HOME = 'https://portal.stedi.com';

/** AC-7: where "Review claims" goes. */
export const BILLING_PATH = '/billing';

export const OPEN_IN_STEDI_LABEL = 'Open in Stedi';
export const REVIEW_CLAIMS_LABEL = 'Review claims';

/** AC-7: the row's own enrollment when Stedi gave us one, else the portal home (Q3). */
export function stediLinkTarget(payer: FoldedPayer): string {
  return payer.portalUrl || STEDI_PORTAL_HOME;
}

const RAIL_TIEBREAK_ORDER = ['837P', '835'];

/**
 * The rail an action and its event describe: the one whose state drove the
 * payer's fold, tie-broken 837P before 835 — the same rail
 * `foldPayers` took "what's happening" from, so the row's text and the
 * event's `enrollment_status` can never disagree.
 */
export function actionRail(payer: FoldedPayer): RailView | undefined {
  const rails = Object.values(payer.rails).filter((rail): rail is RailView => Boolean(rail));
  const matching = rails.filter(rail => rail.state === payer.state);
  const candidates = matching.length > 0 ? matching : rails;
  return candidates.slice().sort((a, b) => {
    const aIdx = RAIL_TIEBREAK_ORDER.indexOf(a.transactionType);
    const bIdx = RAIL_TIEBREAK_ORDER.indexOf(b.transactionType);
    return (
      (aIdx === -1 ? RAIL_TIEBREAK_ORDER.length : aIdx) -
      (bIdx === -1 ? RAIL_TIEBREAK_ORDER.length : bIdx)
    );
  })[0];
}
